import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Set from "@babel/runtime-corejs3/core-js/set";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
export const SET_MORTGAGES = "SET_MORTGAGES";
export const SET_ACTIVITIES = "SET_ACTIVITIES";
export const SET_BIRTHDAYS = "SET_BIRTHDAYS";
export const SET_CLIENT_ACTIVITY = "SET_CLIENT_ACTIVITY";
export const RESET_CLIENT_ACTIVITY = "RESET_CLIENT_ACTIVITY";
export const SET_D2L_SUBMISSIONS = "SET_D2L_SUBMISSIONS";
export const SET_YOY_SUBMITTED = "SET_YOY_SUBMITTED";
export const SET_CLOSES = "SET_CLOSES";
export const SET_COMPLETED_APPS = "SET_COMPLETED_APPS";
export const SET_IN_PROGRESS_APPS = "SET_IN_PROGRESS_APPS";
const mutations = {
  [SET_MORTGAGES]: (state, {
    days,
    agentUsername,
    status,
    clients
  }) => {
    Vue.set(state.informationalCards, "mortgages", {
      clients,
      numberOfDays: days,
      agentUsername,
      status
    });
  },
  [SET_ACTIVITIES]: (state, {
    clients,
    days,
    expired
  }) => {
    Vue.set(state.informationalCards, "activities", {
      clients,
      numberOfDays: days,
      expired
    });
  },
  [SET_BIRTHDAYS]: (state, {
    clients,
    days,
    agentUsername
  }) => {
    Vue.set(state.informationalCards, "birthdays", {
      clients,
      numberOfDays: days,
      agentUsername
    });
  },
  [RESET_CLIENT_ACTIVITY]: state => {
    state.clientActivity = {
      byId: {},
      allIds: []
    };
  },
  [SET_CLIENT_ACTIVITY]: (state, {
    clients
  }) => {
    state.clientActivity.byId = _objectSpread(_objectSpread({}, state.clientActivity.byId), clients.byId);
    state.clientActivity.allIds = [...new _Set([...state.clientActivity.allIds, ...clients.allIds])];
  },
  [SET_D2L_SUBMISSIONS]: (state, {
    submissions
  }) => {
    state.d2lSubmissions = submissions;
  },
  [SET_YOY_SUBMITTED]: (state, {
    applications
  }) => {
    state.charts.appsReceived = applications;
  },
  [SET_CLOSES]: async (state, {
    currentMonth,
    previousMonth
  }) => {
    state.charts.closes.currentMonth = currentMonth;
    state.charts.closes.previousMonth = previousMonth;
  },
  [SET_COMPLETED_APPS]: async (state, {
    applications
  }) => {
    state.charts.applications.completed = applications;
  },
  [SET_IN_PROGRESS_APPS]: async (state, {
    applications
  }) => {
    state.charts.applications.inProgress = applications;
  }
};
export default mutations;